import * as React from 'react'
import styled from 'styled-components'

interface ImgXY {
	url: string
	x: string | number
	y: string | number
	breakpoint: string
}

export interface ImageBackgroundProps {
	bgSet: ImgXY[]
	children?: React.ReactNode
	className?: string
	contentClassName?: string
	title?: string
}

const ImageBackground: React.FC<ImageBackgroundProps> = ({ bgSet, children, className, contentClassName, title }) => {
	return (
		<HeroContainer
			className={className}
			bgSet={bgSet}
			title={title || 'background image'}
		>
			<HeroContent className={contentClassName}>{children}</HeroContent>
		</HeroContainer>
	)
}

const HeroContainer = styled.div`
	height: 0;
	position: relative;
	background-size: 100%;
	background-repeat: no-repeat;

	${(p: Partial<Props>) =>
		p.bgSet.map(
			(img_xy) => `
    @media (min-width: ${img_xy.breakpoint}) {
      background-image: url("${img_xy.url}");      
      padding-top: calc(${img_xy.y}/${img_xy.x} * 100%);
    }
  `
		)}
`

const HeroContent = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;

	> * {
		height: 100%;
	}
`

export default ImageBackground
